export const formatCurrency = (amount: number, currency = 'DOP') => {
  return Intl.NumberFormat('es-DO', {
    style: 'currency',
    currency,
  }).format(amount)
}
